import { put, takeEvery } from 'redux-saga/effects';

import { InstallmentAction } from '../actions';
import { InstallmentConstant } from '../constants';

export default function* () {
  yield takeEvery(
    InstallmentConstant.GET_INSTALLMENTS_SUCCESS,
    getInstallmentsSuccess,
  );
}

function* getInstallmentsSuccess(action) {
  yield put(InstallmentAction.setInstallments(action?.payload));
}
